import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { getToolByPath } from '@/tools/registry';

const BASE_TITLE = '0x-tools';

export function SEO() {
  const location = useLocation();
  const tool = getToolByPath(location.pathname);

  useEffect(() => {
    // Update document title
    if (tool && tool.id !== 'home') {
      document.title = `${tool.meta.title} - ${BASE_TITLE}`;
    } else {
      document.title = `${BASE_TITLE} - Privacy-First Developer Utilities`;
    }

    // Update meta description
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription && tool) {
      metaDescription.setAttribute('content', tool.meta.description);
    }
  }, [location.pathname, tool]);

  return null;
}
